function onlyUnique(value, index, array) {
  return array.indexOf(value) === index;
}
let allProvinces = window.storeData.locations.map((loc) => { return loc.province_code})
window.storeData.provinces = allProvinces.filter(onlyUnique);

var fulfilmentCenterApp = new Vue({
    el: "#fulfilment-center-section",
    data: {
      locations: window.storeData.locations,
      vendors: window.storeData.vendors,
      mapSettings: window.storeData.mapSettings,
      provinces: window.storeData.provinces ,
      currentLocations: window.storeData.locations,
      currentVendors: window.storeData.vendors,
      currentProvince: [window.storeData.provinces[0]],
      map: null,
      markers: [],
      filters: [],
      currentFilters: [],
      currentLocation: "",
    },
    watch: {},
    methods: {
      locationVendors: function () {
        let tempVendors = [];
        let allV = [
          {
            name: "All Vendors",
            logo: "",
            image: "",
            url: "",
            description: "",
            province: this.provinces.map(({ abbreviation }, index) => {
              return abbreviation;
            }),
          },
        ];
        for (i = 0; i < this.locations.length; i++) {
          tempVendors = [...tempVendors, ...this.locations[i].brand];
        }
        let allVendors = [...new Set(tempVendors)];
        let activeVendors = this.vendors.filter((vendor) =>
          allVendors.includes(vendor.name)
        );
        this.vendors = [
          ...allV,
          ...activeVendors.map((vendor) => {
            let vendorlocations = this.locations.filter((location) =>
              location.brand.includes(vendor.name)
            );
            let provinces = [
              ...new Set(
                vendorlocations.map(({ province_code }, index) => {
                  return province_code;
                })
              ),
            ];
            return { ...vendor, province: provinces };
          }),
        ];
        this.currentVendors = this.vendors;
      },
      selectVendor(vendor) {
        if (this.currentProvince[0].abbreviation === "ALL") {
          this.currentLocations =
            vendor === "All Vendors"
              ? this.locations
              : this.locations.filter((location) =>
                  location.brand.includes(vendor)
                );
        } else {
          this.currentLocations =
            vendor === "All Vendors"
              ? this.locations.filter((location) =>
                  location.province_code.includes(
                    this.currentProvince[0].abbreviation
                  )
                )
              : this.locations.filter(
                  (location) =>
                    location.brand.includes(vendor) &&
                    location.province_code.includes(
                      this.currentProvince[0].abbreviation
                    )
                );
        }
        this.setMarkers(this.currentLocations);
        //this.currentVendors = this.vendors.filter(ven => ven.name.includes(vendor));
        $(".vendor-location_results").removeClass("active");
        $(".vendor-location_posts-row").empty();
        $(".vendor-location_posts").addClass('hidden');
      },
      selectProvince(province) {
        //console.log(province)
        this.currentProvince = this.provinces.filter((p) =>
          p.abbreviation.includes(province)
        );

        this.currentVendors =
          province === "ALL"
            ? this.vendors
            : this.vendors.filter((ven) => ven.province.includes(province));
        this.selectVendor("All Vendors");
        //this.currentLocations = this.locations.filter(location => location.brand.includes(vendor));
        //this.currentVendors = this.vendors.filter(ven => ven.name.includes(vendor));
        //$('.vendor-location_results').removeClass('active');
        //$('.vendor-location_posts-row').empty();
      },
      selectLocation: function (e) {
        let target = $(e.target);
        var elm = target;
        if (!target.hasClass("brand-store_location")) {
          elm = target.closest(".brand-store_location");
        }
        let marker = elm.attr("data-marker");
        let location = this.currentLocations[marker];
        this.markerCenter(location.latitude, location.longitude);
        let region = elm.attr("data-region");
        let brand = elm.attr("data-brand");

        /* reset filters - START */
        let oldFilters = this.currentFilters;
        let newFilters = oldFilters.map((current) => {
          return { ...current, value: "", tag: "" };
        });
        this.currentFilters = newFilters;
        /* reset filters - END */
        $(".brand-store_location").removeClass("active");
        elm.addClass("active");
        $(".vendor-location_results").addClass("active");
        this.currentLocation = region + "+" + brand;
        this.getPosts(this.currentLocation);
      },
      getPosts(tags) {
        $(".vendor-location_posts-row").empty();
        $(".vendor-location_posts-loader").addClass("active");
        $.get("/collections/all/" + tags + "/?view=data")
          .done(function (html) {
            let rscript = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
            let newDom = $("<div></div>").append(html.replace(rscript, ""));
            $(".vendor-location_posts-row").html(
              newDom.find("#product-grid").html()
            );
            checkCartSmples();
            $(".vendor-location_posts").removeClass('hidden');
          })
          .fail(function (error) {
            elm.removeClass("active");
          })
          .always(function () {
            $(".vendor-location_posts-loader").removeClass("active");
          });
      },
      markerCenter(lat, lan) {
        this.map.setCenter(new google.maps.LatLng(lat, lan));
        this.map.setZoom(this.mapSettings.zoom);
      },
      setMarkers(locations) {
        //let this.markers = google.maps.Marker[] = [];
        for (var i = 0; i < this.markers.length; i++) {
          this.markers[i].setMap(null);
        }
        this.markers = [];

        let infoWindow = new google.maps.InfoWindow();
        let marker;
        let bounds = new google.maps.LatLngBounds();

        for (i = 0; i < locations.length; i++) {
          let position = new google.maps.LatLng(
            locations[i].latitude,
            locations[i].longitude
          );

          bounds.extend(position);

          marker = new google.maps.Marker({
            position: position,
            //map: this.map,
            //icon: locations[i][5],
            address: locations[i].address2,
            title: locations[i].name,
            html: `<strong>${locations[i].name}</strong><br>${locations[i].address2}<br><a href="${locations[i].direction}" target="_blank" class="d-none" style="color:#000000;">Direction</a>`,
          });

          this.markers.push(marker);

          google.maps.event.addListener(
            marker,
            "click",
            (function (marker, i) {
              return function () {
                infoWindow.setContent(marker.html);
                infoWindow.open(this.map, marker);
              };
            })(marker, i)
          );
        }

        for (let i = 0; i < this.markers.length; i++) {
          this.markers[i].setMap(this.map);
        }
        if (this.markers.length > 1) {
          this.map.fitBounds(bounds, 1);
        } else {
          //console.log(locations[0])
          //this.map.setCenter(new google.maps.LatLng(lat, lan));
          this.markerCenter(locations[0].latitude, locations[0].longitude);
          //this.map.setCenter( new google.maps.LatLng(locations[0].latitude, locations[0].longitude) );
        }
      },
      mapInit() {
        this.map = new google.maps.Map(
          document.getElementById("vendor-store-location"),
          {
            zoom: this.mapSettings.zoom,
            center: new google.maps.LatLng(
              this.locations[0].latitude,
              this.locations[0].longitude
            ),
            //mapTypeId: google.maps.MapTypeId.ROADMAP
            zoomControl: this.mapSettings.zoomControl,
            mapTypeControl: this.mapSettings.mapTypeControl,
            scaleControl: false,
            streetViewControl: this.mapSettings.streetViewControl,
            rotateControl: false,
            fullscreenControl: this.mapSettings.fullscreenControl,
          }
        );
      },
      setFilters() {
        if (window.storeData.filters.length) {
          var setCurrentFilters=[];
          let filters = window.storeData.filters.map((filter) => {
            let currFilter = {};
            currFilter.label = filter.name;
            currFilter.id = filter.name
              .trim()
              .toLowerCase()
              .replace(/'/g, "")
              .replace(/[^a-z0-9+]+/g, "_");
            currFilter.filter = filter.filter.split(",").map((fil) => {
              return {
                label: fil.trim(),
                value: fil
                  .trim()
                  .toLowerCase()
                  .replace(/'/g, "")
                  .replace(/[^a-z0-9+]+/g, "-"),
              };
            });
            setCurrentFilters.push({
              filter: currFilter.id,
              value: "",
              tag: "",
            });
            return currFilter;
          });
          this.currentFilters = setCurrentFilters;
          this.filters = filters;
        }
      },
      selectFilter: function (label, item, t) {
        let oldFilters = this.currentFilters;
        let newFilters = oldFilters.map((current) => {
          if (current.filter === label) {
            return { ...current, value: item, tag: t };
          }
          return current;
        });
        this.currentFilters = newFilters;
        let filterTags = this.currentFilters.map((current) => {
          if (current.tag != "") {
            return current.tag;
          }
        });
        let filterTagsString = filterTags.length
          ? this.currentLocation + "+" + filterTags.join("+")
          : this.currentLocation;
        this.getPosts(filterTagsString);
      },
      clearFilter: function (f) {
        let oldFilters = this.currentFilters;
        let newFilters = oldFilters.map((current) => {
          if (current.filter === "all" || current.filter === f) {
            return { ...current, value: "", tag: "" };
          }
          return current;
        });
        this.currentFilters = newFilters;

        /* get new posts */
        let filterTags = this.currentFilters.map((current) => {
          if (current.tag != "") {
            return current.tag;
          }
        });
        let filterTagsString = filterTags.length
          ? this.currentLocation + "+" + filterTags.join("+")
          : this.currentLocation;
        this.getPosts(filterTagsString);
      },
    },
    beforeMount() {
      this.locationVendors();
      //this.mapInit();
      //this.setFilters();
    },
    mounted() {
      //this.mapInit();
      let selLocation = getUrlParameter("location");
      let selBrand = getUrlParameter("brand");
      if (selLocation) {
        this.currentLocations = this.locations.filter(
          (location) => location.id == selLocation
        );
      } else {
        if (selBrand) {
          let hasSelBrand = this.locations.filter((location) =>
            location.brand.includes(selBrand)
          );
          if (hasSelBrand) {
            this.currentLocations = hasSelBrand;
          } else {
            this.currentLocations = this.locations;
          }
        } else {
          this.currentLocations = this.locations;
        }
      }
      
      setTimeout(()=>{
        this.mapInit();
        this.setMarkers(this.currentLocations);
      },1000);
      
    },
  });
